import { useState, useEffect } from 'react';

export function useContinue(condition) {
  const [validForm, setValidForm] = useState(false);

  useEffect(() => {
    if (condition) {
      setValidForm(true);
    } else {
      setValidForm(false);
    }
  }, [condition]);

  return validForm;
}
